import { Component } from '@angular/core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BeneficioService } from 'src/app/pages/privado/services/previdencia/beneficio.service';
import { ModalDetalheBeneficioComponent } from 'src/app/shared/modals/modal-detalhe-beneficio/modal-detalhe-beneficio.component';
@Component({
  selector: 'app-minhas-solicitacoes-beneficio',
  templateUrl: './minhas-solicitacoes-beneficio.component.html',
  styleUrls: ['./minhas-solicitacoes-beneficio.component.css']
})
export class MinhasSolicitacoesBeneficioComponent {
  //Icones
  faEye = faEye;
  //Variaveis
  listaSolicitacoes: any;
  //Objeto
  filter: any = { ItemsPerPage: 5, Page: 1, IsPaginated: true };
  constructor(private benefitService: BeneficioService, private modalService: NgbModal) {
    this.getFilter(this.filter);
  }
  getFilter(filter: any) {
    this.benefitService.getBenefits(filter).subscribe((res: any) => {
      this.listaSolicitacoes = res;
    });
  }
  detalhesBeneficio(solicitacao: any) {
    const modalRef = this.modalService.open(ModalDetalheBeneficioComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.beneficio = solicitacao;
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.filter.ItemsPerPage = quantidade;
    this.filter.Page = 1;
    this.getFilter(this.filter);
  }
  onChangePagination(page: number) {
    this.filter.Page = page;
    this.getFilter(this.filter);
  }
}
